import axios from 'axios'

const baseURL =
    process.env.REACT_APP_HMS_API_URL || '/hms/v1.0';

const instanceImage = axios.create({
    baseURL,
});

instanceImage.interceptors.request.use(
    config => {
        const token = sessionStorage.getItem('admin-token');
        let hospital = null;
        try {
            hospital = JSON.parse(sessionStorage.getItem('hmsv2-hospital') || 'null');
        } catch {
            hospital = null;
        }

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        config.headers.dbname = hospital?.dbName || '';

        if (config.data instanceof FormData) {
            delete config.headers['Content-Type'];
        }

        return config;
    },
    error => {
        return Promise.reject(error)
    }
);

export default instanceImage
